import React, { useMemo } from 'react'
import { FormBaseSubentity } from './form-base-subentity'
import { BaseEditorCheckbox } from '../base-editor-checkbox'
import {
  FormCheckboxInterface,
  FormInterface,
} from 'src/shared/types/entities/form-interface'
import { useUpdateFormSubentityProps } from './hooks/use-update-form-subentity-prop'
import { useManagement } from 'client/store'
import { getSettingsEditing } from 'client/reducers/managementReducer'

interface FormCheckboxSubentityProps {
  formEntity: FormInterface
  checkboxSubentity: FormCheckboxInterface
}

export const FormCheckboxSubentity = ({
  formEntity,
  checkboxSubentity,
}: FormCheckboxSubentityProps) => {
  const entity = useMemo(
    () => ({
      ...checkboxSubentity,
      ...formEntity.checkboxesCommonStyles,
    }),
    [checkboxSubentity, formEntity.checkboxesCommonStyles],
  )

  const editingFormSubentityId = useManagement(getSettingsEditing).subentityId

  const updateProps = useUpdateFormSubentityProps(formEntity, checkboxSubentity)
  return (
    <FormBaseSubentity
      formEntity={formEntity}
      subentity={checkboxSubentity}
      title={'entity_settings.checkbox.header'}
    >
      <BaseEditorCheckbox
        entity={entity}
        isEditing={editingFormSubentityId === checkboxSubentity.id}
        checked={false}
        onChange={() => {}}
        updateText={updateProps}
      />
    </FormBaseSubentity>
  )
}
